export default __webpack_public_path__ + "static/media/abbott.f037de40.png";